import numberFormatter from "@/services/number.formatter";

export type Interval = {
  upperLimit: number;
  amount: number;
};

export function createNewDefaultInterval(
  intervals: Array<Interval>,
  options: any
): Interval {
  options.startsAt = options.startsAt || 0;
  options.defaultAmount = options.defaultAmount || 1;
  options.defaultIncrement = options.defaultIncrement || 1000000;

  if (intervals.length == 1) {
    const previous = intervals[0];
    return {
      upperLimit: previous.upperLimit * 2 - options.startsAt,
      amount: numberFormatter.atMostTwoDecimalPlaces(previous.amount * 2),
    };
  } else if (intervals.length > 1) {
    const penultimate = intervals[intervals.length - 2];
    const previous = intervals[intervals.length - 1];
    return {
      upperLimit: previous.upperLimit * 2 - penultimate.upperLimit,
      amount: numberFormatter.atMostTwoDecimalPlaces(
        previous.amount * 2 - penultimate.amount
      ),
    };
  } else {
    return {
      upperLimit: options.startsAt + options.defaultIncrement,
      amount: numberFormatter.atMostTwoDecimalPlaces(options.defaultAmount),
    };
  }
}
